import axios from 'axios'

export default () => {
  if (process.env.NODE_ENV == 'production') {
    return axios.create({
      baseURL: `https://partner-api.anytimebooking.eu/`
      // baseURL: `http://localhost:3000`
    })
  } else {
    return axios.create({
      baseURL: `https://partner-api.anytimebooking.eu/`
      // baseURL: `http://localhost:3003`
    })
  }
}
// can be used to hit our end points
